module.exports = __webpack_public_path__ + "media/src/images/partners/auoas-5b9535b08e70a497cc512e43da25f6c2.jpg";